module.exports = __webpack_public_path__ + "fonts/NotoSansCJKkr-Bold.38c81d5e.otf";